export type ConnectionDecisionInput = {
  decision: "approve" | "reject";
  targetRequestId: string;
};

export type ConnectionDecisionDraft = ConnectionDecisionInput & {
  source: "experience_twenty";
  status: "requested";
};

export type ConnectionDecisionResult =
  | {
      ok: true;
      draft: ConnectionDecisionDraft;
    }
  | {
      ok: false;
      errors: string[];
    };

const requestIdLimit = 140;

export function evaluateConnectionDecisionInput(
  input: ConnectionDecisionInput,
): ConnectionDecisionResult {
  const targetRequestId = input.targetRequestId.trim();
  const errors: string[] = [];

  if (!targetRequestId) {
    errors.push("Connection request ID is required.");
  } else if (targetRequestId.length > requestIdLimit) {
    errors.push(`Connection request ID must be ${requestIdLimit} characters or fewer.`);
  }

  if (input.decision !== "approve" && input.decision !== "reject") {
    errors.push("Connection decision must be approve or reject.");
  }

  if (errors.length > 0) {
    return { ok: false, errors };
  }

  return {
    ok: true,
    draft: {
      decision: input.decision,
      source: "experience_twenty",
      status: "requested",
      targetRequestId,
    },
  };
}
